import NavBar from "./NavBar";
import Projects from "./Projects";
import About from "./About";
import Experience from "./Experience";
//import Contact from "./Contact";
import LogoScreen from "./Logo";
import "./styles/Home.css";

const Home = () => {
  return (
    <div className="section">
      <NavBar />
      <LogoScreen />
      <div id="left-column">
        <About />
        <Projects />
      </div>
      <div id="right-column">
        <Experience />
      </div>
      {/*<Contact />*/}
    </div>
  );
};

export default Home;
